import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import AdminRoute from "./Components/PrivateRoutes/AdminRoutes";
import {
    PageNotFound404,
    Forbidden,
    Home,
    Contact,
    Company,
    ThanksPage,
    LoginAdmin,
    HomeAdmin,
    User,
    Client,
    Product,
    Aplications,
    Lines,
    Products,
    Clients,
    ProductsAndMarket,
    Users,
    LogsCDOC,
    New,
    News,
    CDOC,
    TermsOfUseCDOC,
    GsSolutions,
    AboutInputs,
    Settings,
    Cookies,
    Releases,
    Release,
    AccessoriesAndEquipment,
    AccessoryAndEquipment,
    GraphicMaterials,
    GraphicMaterial,
    Events,
    Event,
} from "../pages";
import {
    ADMIN_ROLE_ID,
    OPERATIONAL_ROLE_ID,
} from "../service/authorization";

const Routes = () => (
    <BrowserRouter>
        <Switch>
            <AdminRoute
                path="/ctop/settings"
                exact
                component={Settings}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/produtos/linhas"
                exact
                component={Lines}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/produtos/linhas/:id"
                exact
                component={Lines}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/produtos/aplicacoes"
                exact
                component={Aplications}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/produtos/aplicacoes/:id"
                exact
                component={Aplications}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/produtos"
                exact
                component={Products}
                allowedRoles={[ADMIN_ROLE_ID, OPERATIONAL_ROLE_ID]}
                requireReadOnlyProduct
            />
            <AdminRoute
                path="/ctop/produto"
                exact
                component={Product}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/produto/:id"
                exact
                component={Product}
                allowedRoles={[ADMIN_ROLE_ID, OPERATIONAL_ROLE_ID]}
                requireReadOnlyProduct
            />

            <AdminRoute
                path="/ctop/clientes"
                exact
                component={Clients}
                allowedRoles={[ADMIN_ROLE_ID, OPERATIONAL_ROLE_ID]}
            />

            <AdminRoute
                path="/ctop/cliente/:id"
                exact
                component={Client}
                allowedRoles={[ADMIN_ROLE_ID, OPERATIONAL_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/cliente/"
                exact
                component={Client}
                allowedRoles={[ADMIN_ROLE_ID, OPERATIONAL_ROLE_ID]}
            />

            <AdminRoute
                path="/ctop/usuarios"
                exact
                component={Users}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/usuario"
                exact
                component={User}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/usuario/:id"
                exact
                component={User}
                allowedRoles={[ADMIN_ROLE_ID]}
            />

            <AdminRoute
                path="/ctop/noticias"
                exact
                component={News}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/noticia"
                exact
                component={New}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/noticia/:id"
                exact
                component={New}
                allowedRoles={[ADMIN_ROLE_ID]}
            />

            <AdminRoute
                path="/ctop/acessorios-e-equipamentos"
                exact
                component={AccessoriesAndEquipment}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/acessorio-e-equipamento"
                exact
                component={AccessoryAndEquipment}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/acessorio-e-equipamento/:id"
                exact
                component={AccessoryAndEquipment}
                allowedRoles={[ADMIN_ROLE_ID]}
            />

            <AdminRoute
                path="/ctop/materiais-graficos"
                exact
                component={GraphicMaterials}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/material-grafico"
                exact
                component={GraphicMaterial}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/material-grafico/:id"
                exact
                component={GraphicMaterial}
                allowedRoles={[ADMIN_ROLE_ID]}
            />

            <AdminRoute
                path="/ctop/eventos"
                exact
                component={Events}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/evento"
                exact
                component={Event}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/evento/:id"
                exact
                component={Event}
                allowedRoles={[ADMIN_ROLE_ID]}
            />

            <AdminRoute
                path="/ctop/lancamentos"
                exact
                component={Releases}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/lancamento"
                exact
                component={Release}
                allowedRoles={[ADMIN_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/lancamento/:id"
                exact
                component={Release}
                allowedRoles={[ADMIN_ROLE_ID]}
            />

            <AdminRoute
                path="/ctop/home"
                exact
                component={HomeAdmin}
                allowedRoles={[ADMIN_ROLE_ID, OPERATIONAL_ROLE_ID]}
            />
            <AdminRoute
                path="/ctop/logs-cdoc"
                exact
                component={LogsCDOC}
                allowedRoles={[ADMIN_ROLE_ID, OPERATIONAL_ROLE_ID]}
            />
            <Route path="/ctop/forbidden" exact component={Forbidden} />

            <Route path="/ctop" exact component={LoginAdmin} />

            <Route path="/central-de-documentos" exact component={CDOC} />
            <Route path="/politica-de-privacidade" exact component={Cookies} />
            <Route
                path="/produtos-e-mercado"
                exact
                component={ProductsAndMarket}
            />
            <Route path="/empresa" exact component={Company} />
            <Route
                path="/termos-de-uso-cdoc"
                exact
                component={TermsOfUseCDOC}
            />
            <Route path="/obrigado" exact component={ThanksPage} />
            <Route path="/contato" exact component={Contact} />
            <Route path="/gs-solutions" exact component={GsSolutions} />
            <Route path="/about-inputs" exact component={AboutInputs} />
            <Route path="/" exact component={Home} />
            <Route path="*" component={PageNotFound404} />
        </Switch>
    </BrowserRouter>
);

export default Routes;
